import { GameIds } from '../enums';
import { Game } from '../types';

export const getGameUrl = (
  games: Game[] = [],
  gameId?: string,
  branchDataGroupId?: string
) => {
  const selectedGame = games.find((game: Game) => game.gameId === gameId);
  const selectedGameId = selectedGame?.gameId;
  if (!selectedGame?.uri || !selectedGameId) {
    return '';
  }
  let gameUrl =
    selectedGameId !== GameIds.PICKLE ? selectedGame.uri : '/games/pickle';

  if (branchDataGroupId) {
    gameUrl += `?groupId=${branchDataGroupId}`;
  }
  return gameUrl;
};

export default getGameUrl;
